export default {
  hsk_left_time: 'الوقت المتبقي للامتحان',
  hsk_submit_paper: 'تسليم ورقة الإجابة',
  hsk_not_finished: 'غير مكتمل',
  hsk_not_start: 'لم يبدأ',
  hsk_finished: 'مكتمل',
  hsk_if_test: 'امتحانك السابق لم ينته بعد، هل تريد المتابعة؟',
  hsk_start_again: 'إعادة الامتحان',
  hsk_go_on: 'متابعة الامتحان',
  hsk_if_save: 'هل أنت متأكد من الخروج من الامتحان التجريبي؟ بعد الخروج سيتم حفظ إجاباتك ويمكنك المتابعة لاحقًا.',
  hsk_login_filed: 'معلومات تسجيل الدخول الخاصة بك غير صالحة، لن يتم حفظ إجاباتك.',
  hsk_report: 'تقرير الإجابات',
  hsk_point: 'درجة',
  hsk_qualified_point: '{points} درجة للنجاح',
  hsk_part1: 'الجزء {part}',
  hsk_accuracy1: 'نسبة الدقة',
  hsk_test_again: 'إعادة المحاولة',
  hsk_example: 'مثال',
  hsk_example_eg: 'مثال',
  hsk_answer_analysis: 'تحليل الإجابة:',
  hsk_your_answer: 'إجابتك:',
  hsk_audio_text: 'نص الاستماع:',
  hsk_correct_answer: 'الإجابة الصحيحة:',
  hsk_listen_name: 'الاستماع',
  hskk_listen_name: 'اختبار الجهاز',
  hsk_read_name: 'القراءة',
  hsk_write_name: 'الكتابة',
  hsk_reference_answer: 'الإجابة المرجعية:',
  hsk_reference_answer_hskk: 'محتوى ملف الصوت:',
  hsk_submit_msg: 'هل أنت متأكد من تسليم ورقة الإجابة؟',
  hsk_homework_no_answer: 'لم تتم الإجابة',
  hsk_practice_sava: 'هل تريد الخروج من التمرين؟ لن يتم حفظ إجاباتك.',
  hsk_practice_go: 'اذهب إلى التمرين',
  hsk_practice_part: 'وحدة التمرين',
  hsk_practice_operate: 'إجراء',
  hsk_practice_check: 'عرض',
  hsk_practice_num1: 'إجابات صحيحة',
  hsk_practice_num2: 'سؤال من إجمالي {totalNum} سؤال',
  hsk_preview_listen_msg: 'سيتم الآن تشغيل تعليمات الامتحان، يمكنك معاينة الأسئلة أثناء هذه الفترة.',
  hsk_preview_listen_prompt: 'سيتم الآن تشغيل تعليمات الامتحان، يمكنك معاينة الأسئلة، الرجاء عدم تحديث أو إغلاق الصفحة أثناء الامتحان، وإلا ستفقد البيانات.',
  hsk_enter_next_segment_msg: 'هل أنت متأكد من الانتقال إلى الجزء التالي؟',
  hsk_enter_next_segment_preview: 'هل تريد إنهاء المعاينة؟ بعد الانتهاء ستبدأ مرحلة الاستماع.',
  hsk_enter_next_segment_listen_tip: 'لديك {count} سؤال استماع غير مُجاب،',
  hsk_enter_next_segment_listen: 'هل تريد تسليم الاستماع؟ بعد التسليم، سينتهي جزء الاستماع.',
  hsk_enter_next_segment_listen_review_start: 'الآن هي فترة مراجعة الاستماع، لديك {count} دقيقة لمراجعة الإجابات.',
  hsk_enter_next_segment_listen_review: 'هل تريد إنهاء مراجعة الاستماع؟ بعد الانتهاء ستبدأ مرحلة القراءة.',
  hsk_enter_next_segment_read_tip: 'لديك {count} سؤال قراءة غير مُجاب،',
  hsk_enter_next_segment_read: 'هل تريد تسليم القراءة؟ بعد التسليم سينتهي جزء القراءة ولا يمكن التعديل.',
  hsk_enter_next_segment_write_tip: 'لديك {count} سؤال كتابة غير مُجاب،',
  hsk_enter_next_segment_write: 'هل أنت متأكد من تسليم ورقة الإجابة؟',
  hsk_end_preview: 'إنهاء المعاينة',
  hsk_submit_listen: 'تسليم الاستماع',
  hsk_end_review: 'إنهاء المراجعة',
  hsk_start_exam: 'بدء الامتحان',
  hsk_start_exam_new: 'ابدأ',
  hsk_link_test: 'انقر لبدء اختبار محاكاة كامل',
  hsk_link_tips: 'قم بحل اختبار المحاكاة للحصول على الشهادة الرسمية',
  hsk_buy: 'شراء',
  hsk_test_ready: 'التحضير قبل الامتحان',
  hsk_test_ready_tips: 'يحتوي هذا الامتحان على جزء الاستماع، يرجى ضبط الجهاز مسبقًا.',
  hsk_test_content: 'محتوى الامتحان',
  hsk_test_num: 'عدد الأسئلة',
  hsk_total_num: 'إجمالي الأسئلة',
  hsk_test_time: 'مدة الامتحان',
  hsk_time_total: 'إجمالي الوقت',
  hsk_test_minute: 'دقيقة',
  hsk_about: 'حوالي',
  hsk_abbreviation: 'أريد اختصار',
  hsk_determine_ans: 'هل أنت متأكد من بدء الإجابة؟',
  hsk_determine_ans_tips: 'بعد البدء، لن تتمكن من مراجعة النص مرة أخرى',
  no_data: 'لا توجد بيانات',
  hsk_question_number: 'عدد الأسئلة',
  hsk_test_rate: 'نسبة الامتحان',
  hsk_right_rate: 'نسبة الصحة',
  hsk_operation: 'إجراء',
  hsk_skip: 'تخطي',
  hsk_spend: 'مستغرق',
  hsk_cost: 'مستغرق',
  hsk_credit: 'الرصيد',
  hsk_pay_successfully: 'تم الدفع بنجاح',
  hsk_select_amount: 'اختر مبلغ الشحن',
  button_common_ok: 'تأكيد',
  button_common_cancel: 'إلغاء',
  change_lang_ok: 'تأكيد',
  change_lang_cancel: 'إلغاء',
  hint_player_loader_error: 'فشل تشغيل الصوت',
  hint_common_wait_loading: 'جارٍ تحميل الموارد…',
  button_common_hand_in: 'تسليم',
  test_total_question: 'إجمالي {count} سؤال',
  test_release: 'إصدار',
  test_off_shelf: 'إزالة',
  test_enable: 'تفعيل',
  test_record: 'سجل الامتحان التجريبي',
  test_finish_time: 'وقت الانتهاء',
  test_paper: 'ورقة الامتحان',
  test_confirm_use: 'تأكيد التفعيل',
  test_confirm_off_shelf: 'تأكيد الإزالة',
  test_has_on_shelf: 'مفعل',
  test_un_release: 'غير منشور',
  test_un_enable: 'غير مفعّل',
  test_max_score: 'أعلى درجة',
  test_average_score: 'متوسط الدرجة',
  test_min_score: 'أدنى درجة',
  test_all: 'الكل',
  test_has_practiced: 'تمت الممارسة، عرض النتيجة',
  test_paper_office: 'تمت إزالة ورقة الامتحان!',
  test_complete_introduce: 'مقدمة كاملة',
  test_course_link: 'الدورة الرسمية',
  test_about_down_load: 'تحميلات ذات صلة',
  test_pay: 'دفع',
  mark_answer_user: 'المجيب',
  mark_answer_time: 'وقت الإجابة',
  mark_correct_time: 'وقت التصحيح',
  mark_correct_status: 'حالة التصحيح',
  mark_correct_user: 'المصحح',
  mark_correct_option: 'إجراء',
  mark_correct_ing: 'جارٍ التصحيح',
  mark_un_correct: 'غير مصحح',
  mark_has_correct: 'تم التصحيح',
  mark_report_tips: 'ملاحظة: لم تُحتسب بعد أسئلة الكتابة ضمن الدرجة الكلية. سيتم تصحيح {markNumberDesc} سؤال من قِبل مقيمين محترفين خلال 48 ساعة. بعد الانتهاء ستُحدّث الدرجة الكلية، وسنخطرك عبر البريد الإلكتروني.',
  mark_report_tips_hskk: 'ملاحظة: سيتم تصحيح الأسئلة من قِبل مقيمين محترفين خلال 48 ساعة. بعد الانتهاء ستُحدّث الدرجة الكلية، وسنخطرك عبر البريد الإلكتروني.',
  mark_submit_btn: 'تسليم التصحيح',
  mark_submit_tips: 'هل تؤكد تسليم التصحيح؟',
  mark_back: 'رجوع',
  mark_correct_tips: 'ورقة الامتحان قيد التصحيح، لا يمكن إعادة التصحيح!',
  mark_correct_person: 'تصحيح يدوي',
  search_user_message: 'ابحث باسم المستخدم',
  mark_current_user: 'المستخدم الحالي',
  mark_correct_paper: 'تصحيح',
  mark_all_status: 'جميع الحالات',
  mark_all_level: 'جميع المستويات',
  mark_overtime: 'منتهي الوقت',
  mark_answer: 'إجابة',
  home_test_registration: 'تسجيل الامتحان',
  home_word_outline: 'اختبار المفردات',
  home_online_practice: 'نموذج مجاني',
  home_test: 'محاكاة كاملة',
  home_page: 'الصفحة الرئيسية',
  common_text_control_speed: 'سرعة التشغيل',
  button_common_playback: 'تشغيل التسجيل',
  common_text_file_error: 'فشل تحميل الحزمة، يرجى إعادة المحاولة',
  common_text_server_error: 'حاول مرة أخرى',
  common_text_none_network: 'الشبكة غير مستقرة',
  button_common_start_over: 'إعادة المحاولة',
  evaluating_tips_common: 'تختلف قراءة التسجيل عن النص بشكل كبير، يرجى إعادة التسجيل',
  evaluate_common_total_score: 'الدرجة',
  evaluate_common_training_remain: 'المتبقي:',
  evaluate_common_training_readyRcord: 'التحضير للتسجيل',
  evaluate_common_training_atleast: 'مدة التسجيل يجب أن تزيد عن ثانية واحدة',
  evaluate_common_training_atleast2: 'مدة التسجيل يجب أن تزيد عن ثانيتين',
  evaluate_common_training_evaluting: 'جارٍ التقييم',
  evaluating_tips_additionalAndBack: 'حدثت زيادة/إعادة أثناء القراءة، مما يؤثر على النتيجة النهائية',
  textbook_chioce_word_text_correct_tip: 'إجابة صحيحة، أحسنت!',
  textbook_chioce_word_text_error_tip: 'إجابة خاطئة، واصل المحاولة!',
  textbook_reading_comprehension_stem: 'فهم المقروء',
  spc_back_tips: 'هل تؤكد الخروج من التمرين؟ بعد الخروج لن تُحفظ الإجابات',
  spc_level_text: 'اختبار المستوى',
  spc_capability_assessment: 'تقييم القدرات',
  spc_pick_level: 'اختر المستوى',
  spc_listen: 'استماع',
  spc_speak: 'تحدث',
  spc_read: 'قراءة',
  spc_write: 'كتابة',
  spc_translation: 'ترجمة',
  spc_result_tips: 'بعد الاختبار، مستواك في الصينية يعادل HSK المستوى {level}',
  spc_recommend_test: 'نوصي بالتحضير لـ HSK المستوى {level}',
  spc_recommend_test1: 'نوصي بالتحضير لـ <strong>HSK {level}</strong> المستوى',
  spc_again_test: 'إعادة الاختبار',
  spc_where_tips: 'لست متأكدًا من مستواي في الصينية؟',
  spc_immediate_test: 'اختبر الآن',
  spc_test_content: 'محتوى الاختبار',
  spc_test_content_desc: 'سيتم تقييم المتعلم من خلال خمسة جوانب: الاستماع، التحدث، القراءة (قراءة جهرية)، الكتابة (إدخال يدوي أو اختيار)، والترجمة. تختلف الأسئلة حسب المستوى.',
  spc_test_timer: 'مدة الاختبار',
  spc_test_timer_desc: 'حوالي 15 دقيقة، وكلما ارتفع المستوى زاد الوقت المطلوب.',
  spc_test_result: 'نتيجة الاختبار',
  spc_test_result_desc: 'يساعدك على تحديد مستواك بسرعة وتحسين مهاراتك الخاصة',
  vocab_level_word: 'مفردات المستوى {level}',
  vocab_total_item: 'إجمالي {total} عنصر',
  vocab_search: 'ابحث عن الحرف/拼音/الترجمة',
  vocab_all_marked: 'الكل',
  vocab_already_marked: 'مُعلّم',
  vocab_unmarked: 'غير مُعلّم',
  vocabulary: 'مفردات',
  vocab_pinyin: '拼音',
  vocab_translate: 'ترجمة',
  vocab_mark: 'تعليم',
  delete_confirmation: 'تأكيد حذف المفردة',
  cancel: 'إلغاء',
  del: 'حذف',
  edit_vocab: 'تعديل المفردة',
  save: 'حفظ',
  add_vocab: 'إضافة مفردة',
  hanzi: '汉字',
  num_bihua: 'عدد الخطوط',
  write_demo: 'عرض الكتابة',
  vocab_side: 'الجذر',
  level: 'المستوى الحالي',
  see_more: 'عرض المزيد',
  same_read_word: 'أحرف متشابهة النطق',
  samilar_read_word: 'أحرف قريبة النطق',
  add_mark: 'إضافة علامة',
  word_team: 'تكوين كلمات',
  instance: 'جملة مثال',
  include_num_char: 'يتضمن {total} حرفًا صينيًا',
  length_diff: 'عدد أحرف拼音 لا يتطابق مع عدد الحروف الصينية',
  add_word_success: 'تمت إضافة المفردة بنجاح',
  add_word_fail: 'فشل في إضافة المفردة',
  edit_word_success: 'تم تعديل المفردة بنجاح',
  edit_word_fail: 'فشل في تعديل المفردة',
  del_success: 'تم الحذف بنجاح',
  del_fail: 'فشل في الحذف',
  mark_free: 'يمكن وضع علامة بحرية، مثل "تم الإتقان"',
  write_word_sentence: 'يرجى تأليف جملة باستخدام الكلمة أعلاه…',
  write_word_artical: 'يرجى كتابة مقالة قصيرة باستخدام الكلمات الرئيسية أعلاه…',
  write_img_artical: 'يرجى كتابة مقالة قصيرة باستخدام الصورة أعلاه…',
  write_artical_title: 'يرجى إدخال عنوان المقال…',
  write_artical_content: 'يرجى إدخال نص المقال…',
  my_wallet: 'مشترياتي',
  learn_history: 'سجل التعلم',
  manage: 'إدارة المستخدم',
  birthday: 'تاريخ الميلاد',
  email: 'البريد الإلكتروني',
  change_pw: 'تغيير كلمة المرور',
  edit_info: 'تعديل المعلومات',
  lastName: 'الكنية',
  firstName: 'الاسم',
  gender: 'الجنس',
  female: 'أنثى',
  
  // RTL测试页面翻译
  rtl_test_title: 'اختبار التخطيط من اليمين إلى اليسار',
  rtl_basic_layout_test: 'اختبار التخطيط الأساسي',
  rtl_text_align_test: 'اختبار محاذاة النص',
  rtl_margin_test: 'اختبار الهوامش',
  rtl_padding_test: 'اختبار الحشو',
  rtl_position_test: 'اختبار الموضع',
  rtl_border_test: 'اختبار الحدود',
  rtl_rounded_test: 'اختبار الزوايا المدورة',
  rtl_icon_test: 'اختبار الأيقونات',
  rtl_form_test: 'اختبار النموذج',
  rtl_table_test: 'اختبار الجدول',
  rtl_dialog_test: 'اختبار الحوار',
  rtl_nav_test: 'اختبار التنقل',
  rtl_pagination_test: 'اختبار الترقيم',
  rtl_name: 'الاسم',
  rtl_email: 'البريد الإلكتروني',
  rtl_message: 'الرسالة',
  rtl_submit: 'إرسال',
  rtl_cancel: 'إلغاء',
  rtl_status: 'الحالة',
  rtl_show_dialog: 'إظهار الحوار',
  rtl_dialog_title: 'عنوان الحوار',
  rtl_dialog_content: 'محتوى الحوار',
  rtl_confirm: 'تأكيد',
  rtl_home: 'الرئيسية',
  rtl_about: 'حول',
  rtl_contact: 'اتصل بنا',
  male: 'ذكر',
  non_disclosure: 'غير معلن',
  change_avatar: 'تغيير الصورة الرمزية',
  preview_avatar: 'معاينة الصورة الرمزية',
  upload_image: 'تحميل صورة',
  change_image: 'استبدال الصورة',
  enter_old_pw: 'يرجى إدخال كلمة المرور القديمة',
  enter_new_pw: 'يرجى إدخال كلمة المرور الجديدة',
  enter_new_pw_again: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
  forget_pw: 'نسيت كلمة المرور',
  recharge: 'إعادة الشحن',
  left_balance: 'الرصيد المتاح',
  consume_log: 'إجابات الامتحان',
  recharge_log: 'سجل المشتريات',
  consume_time: 'وقت الاستهلاك',
  consume_source: 'المورد المستهلك',
  consume_money: 'المبلغ المستهلك',
  total_item_log: 'إجمالي {total} سجل',
  recharge_time: 'وقت إعادة الشحن',
  recharge_num: 'كمية إعادة الشحن',
  recharge_money: 'مبلغ إعادة الشحن',
  recharge_method: 'طريقة الدفع',
  learn_content: 'محتوى التعلم',
  total_score: 'المجموع الكلي',
  view_result: 'عرض النتيجة',
  management: 'إدارة المستخدم',
  give_history: 'سجل الإهداءات',
  total_recharge: 'إجمالي إعادة الشحن',
  last_login: 'آخر تسجيل دخول',
  give: 'إهداء',
  gifted: 'مُهدى',
  give_time: 'وقت الإهداء',
  give_to_person: 'الممنوح له',
  opera_person: 'المنفّذ',
  give_to: 'إهداء إلى',
  old_password_empty: 'لا يمكن أن تكون كلمة المرور القديمة فارغة',
  diff_password: 'كلمتا المرور غير متطابقتين',
  change_pw_success: 'تم تغيير كلمة المرور بنجاح',
  change_pw_fail: 'فشل تغيير كلمة المرور',
  change_info_success: 'تم تعديل المعلومات بنجاح',
  change_info_fail: 'فشل تعديل المعلومات',
  statistics_center: 'مركز الإحصائيات',
  select_recharge_mount: 'اختر مبلغ إعادة الشحن',
  waiting_pay: 'بانتظار الدفع...',
  has_no_resolve_credit: 'لم يتم استلام الدفعة بعد، يرجى المحاولة مرة أخرى.',
  complete_pay: 'تم الدفع',
  pay_fail: 'فشل الدفع',
  give_success: 'تم الإهداء بنجاح',
  give_fail: 'فشل الإهداء',
  change_avatar_success: 'تم تغيير الصورة الرمزية بنجاح',
  change_avatar_fail: 'فشل تغيير الصورة الرمزية',
  enter_family_name: 'يرجى إدخال الكنية',
  enter_given_name: 'يرجى إدخال الاسم',
  log_in: 'تسجيل الدخول',
  log_in_error: 'فشل تسجيل الدخول',
  email_address: 'عنوان البريد الإلكتروني',
  invalid_email_address: 'عنوان البريد الإلكتروني غير صالح',
  password: 'كلمة المرور',
  password_tip: 'طول كلمة المرور بين 6-20 خانة',
  invalid_password: 'صيغة كلمة المرور غير صحيحة',
  have_account: 'لديك حساب {text}',
  sign_up: 'تسجيل',
  sign_up_error: 'فشل التسجيل',
  forget_pw_success: 'تم إرسال رسالة إعادة تعيين كلمة المرور بنجاح',
  forget_pw_error: 'فشل إرسال رسالة إعادة تعيين كلمة المرور',
  loading: 'جارٍ التحميل',
  account_block: 'الحساب محظور',
  account_block_tip: 'يرجى التواصل مع مشرف مدرستك للحصول على المزيد من المعلومات',
  resend_email: 'إعادة إرسال البريد الإلكتروني',
  resend_email_success: 'تمت إعادة إرسال البريد الإلكتروني',
  resend_email_error: 'فشلت إعادة إرسال البريد الإلكتروني',
  i_am: 'أنا',
  choose_role: 'أي وصف يناسبك أكثر',
  choose_role_error: 'فشل في اختيار الدور',
  continue: 'متابعة',
  learner: 'طالب',
  learner_description: 'أنا أتعلم الصينية',
  teacher: 'معلم',
  teacher_description: 'أنا أُدرّس الصينية',
  setup_account_error: 'فشل في إعداد معلومات الحساب',
  tos_link: 'شروط الخدمة',
  privacy_link: 'سياسة الخصوصية',
  email_verified: 'تم التحقق من البريد الإلكتروني!',
  email_verified_tip: 'شكرًا لتأكيد بريدك الإلكتروني.',
  email_verified_error: 'تعذّر التحقق من حسابك',
  something_wrong: 'حدث خطأ ما',
  retry: 'إعادة المحاولة',
  guardian_consent_error: 'فشلت العملية',
  about_us: 'من نحن',
  about_us_new: 'من نحن',
  feedback: 'اتصل بنا',
  download: 'تحميل',
  submit: 'إرسال',
  feedback_success: 'تم الإرسال بنجاح',
  feedback_error: 'فشل الإرسال',
  logout: 'تسجيل الخروج',
  my_account: 'حسابي',
  login_signup: 'تسجيل الدخول / التسجيل',
  please_enter_content: 'يرجى إدخال محتوى الملاحظات (إلزامي)',
  describe_detail: 'إذا كنت تصف مشكلة، يرجى تقديم أكبر قدر ممكن من التفاصيل',
  upload_picture: 'تحميل الصور (اختياري، بحد أقصى {maxFiles} صور. يدعم JPG/PNG، لا تتجاوز الصورة الواحدة 2M)',
  file_error: 'تنسيق الملف أو حجمه غير صحيح',
  file_num_limit: 'يمكن تحميل {maxFiles} ملفات كحد أقصى',
  sure_change_lang: 'تأكيد تغيير اللغة؟',
  privacy_policy_text1: 'HSK Mock.com — المنصة الوحيدة المعتمدة رسميًا من Hanban للاختبارات التجريبية',
  privacy_policy_text2: 'تم تطوير وتشغيل منصة المحاكاة من قبل Wo Hui وHanban استنادًا إلى بنك أسئلة HSK وYCT. توفر تدريبًا كاملًا على اختبارات حقيقية لتأمين اختبارات اللغة الصينية القياسية للمتعلمين.',
  privacy_policy_text3: 'Wo Hui Mandarin هو شريك رسمي لـ Hanban.',
  privacy_policy_text4: 'Hanban International Education Technology (Beijing) Co., Ltd. هي مؤسسة متخصصة في خدمات التعليم والاختبارات الدولية للغة الصينية. تلتزم بتقديم خدمات مهنية في تصميم البحث، التطوير التكنولوجي، تنفيذ الامتحانات، والتسويق لتلبية احتياجات المتعلمين ومؤسسات التعليم الصيني حول العالم.',
  privacy_policy_text5: 'تم تأسيس Wo Hui من قبل مجموعة EiM الدولية للتعليم في سنغافورة عام 2018. وهي شركة مستقلة مكرسة لتوفير الدعم التكنولوجي والخدمات للمتعلمين حول العالم. تقدم دورات متنوعة للطلاب وموارد وأدوات تعليمية ضخمة للمعلمين. تدعم التكنولوجيا الذكية التدريس، وتحرر أيدي المعلمين، وتحسن عملية التعليم، وتساعد الطلاب على تحقيق أهدافهم الشخصية وتشجعهم على أن يصبحوا متعلمين مستقلين متميزين.',
  privacy_policy_text6: 'تتمتع Hanban وWo Hui بأساس جيد للتعاون، حيث يعملان معًا على تعزيز وتطوير تعلم اللغة الصينية. ومن خلال التعاون الاستراتيجي العميق، يهدفان إلى توفير بيئة اختبار أكثر واقعية وتلبية جميع احتياجات المتعلمين بشكل شامل.',
  level_test: 'اختبار المستوى',
  level_test_example: 'إذا لم تكن متأكدًا من مستواك، يمكنك المشاركة في اختبار سريع مجاني لمعرفة المستوى المناسب لك لتحديد أهدافك التعليمية.',
  download_app_mobile: 'للحصول على تجربة أفضل، يرجى استخدام النسخة المكتبية من hskmock.com أو تنزيل التطبيق',
  common_video_failed: 'فشل تحميل الصوت',
  member_error: 'مورد غير طبيعي!',
  agree_policy: 'لقد قرأت ووافقت على <u class="strong"><a href="{url}" target="_blank">《اتفاقية المستخدم》</a></u> و<u class="strong"><a href="{userUrl}" target="_blank">《سياسة الخصوصية》</a></u>',
  please_check: 'يرجى تحديد أنك قرأت ووافقت على 《اتفاقية المستخدم》 و《سياسة الخصوصية》',
  media_devices_unsupported_browserLabel: 'يُوصى بتعيين متصفح Google Chrome كالمتصفح الافتراضي. على سبيل المثال في Windows10: الإعدادات - التطبيقات - التطبيقات الافتراضية - المتصفح - اختر Google Chrome',
  media_devices_help_title: 'هل تريد تشغيل الميكروفون',
  media_devices_help_content: 'تحتاج إلى تشغيل الميكروفون لتسجيل الصوت',
  batch_exist_user: '{number} مستخدم مسجل',
  batch_and: 'و',
  batch_un_exist_user: '{number} مستخدم غير مسجل',
  batch_from: 'من',
  batch_notes: 'ملاحظات',
  batch_something: 'يرجى الإدخال',
  batch_people_number: 'عدد الممنوحين',
  batch_use_number2: 'مقدار الاستهلاك',
  batch_operation_status: 'حالة العملية',
  batch_ing_status: 'قيد التنفيذ',
  batch_success: 'نجاح',
  batch_failed: 'فشل',
  batch_select: 'يرجى الاختيار',
  common_to: 'إلى',
  common_start_time: 'تاريخ البدء',
  common_end_time: 'تاريخ الانتهاء',
  batch_search_tips: 'ألصق أسماء حسابات المستخدمين هنا (افصلها بفواصل، يمكن استيراد ما يصل إلى 50 مستخدمًا في كل مرة)',
  common_un_exist: 'غير مسجل',
  common_invalid: 'غير صالح',
  batch_all_give: 'إهداء جماعي للأوراق',
  batch_single_people: 'فردي',
  batch_all: 'جماعي',
  batch_name: 'الاسم',
  batch_added_credits: 'عدد الإهداءات',
  batch_spent_credits: 'عدد المستهلك',
  batch_account_status: 'حالة الحساب',
  batch_Added_total: 'إجمالي الإهداءات',
  batch_spent_total: 'إجمالي الاستهلاك',
  batch_Remaining: 'المتبقي',
  batch_Recipients: 'الممنوح له',
  batch_Active: 'مفعل',
  batch_search: 'بحث',
  certificate_details: 'تفاصيل الشهادة',
  get_official_mock_certificate: 'الحصول على شهادة محاكاة رسمية',
  certificate_tips: 'تفاصيل الشهادة مأخوذة من معلوماتك الشخصية. يرجى التأكد من صحتها:',
  country: 'الجنسية',
  select_country: 'يرجى اختيار الجنسية',
  email_to: 'سيتم إرسال الشهادة عبر البريد الإلكتروني إلى:',
  polyphonic: 'أحرف متعددة النطق',
  click_tips: 'انقر على رقم السؤال لعرض الإجابة',
  download_tips: 'يمكنك تنزيل شهادة الاختبار التجريبي عند اجتياز النتيجة',
  cancel_delete_account: 'إلغاء الحساب',
  cancel_confirm: 'تأكيد',
  user_apply_delete_account_title: 'طلب إلغاء الحساب',
  user_apply_delete_account_confirm_tip: 'تأكيد معلومات تسجيل الدخول الخاصة بك',
  user_apply_delete_account_alwaysTip: 'أنت تطلب الآن حذف حساب الاختبار التجريبي وبياناتك الشخصية بشكل دائم.',
  user_apply_delete_account_confirm_tip2: 'يرجى تأكيد هويتك قبل تقديم الطلب.',
  user_apply_delete_account_desc: 'يُستخدم حسابك {email} لتسجيل الدخول إلى <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> و <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2: 'بعد الإلغاء لن تتمكن من استخدام هذا الحساب لتسجيل الدخول إلى التطبيقات المذكورة أعلاه.',
  user_apply_delete_account_wohui_title: 'إلغاء اشتراك Wo Hui',
  user_apply_delete_account_hsk_title: 'رصيد HSK MOCK',
  user_apply_delete_account_next_tip: 'انقر فوق الزر "التالي" لتأكيد أنك قرأت ووافقت على ما ورد أعلاه.',
  user_apply_delete_account_next_title: 'التالي',
  user_apply_delete_account_confirm_tip11: 'قم بإلغاء اشتراكك قبل إتمام طلب حذف الحساب',
  cancel_delete_ok: 'حسنًا',
  cancel_delete_request_send: 'إرسال الطلب',
  user_apply_delete_account_confirm_tip8: 'سيتم حذف حسابك نهائيًا عند انتهاء اشتراكك في {date}',
  user_apply_delete_account_confirm_tip4: 'سوف نرسل رسالة إلى',
  user_apply_delete_account_confirm_tip5: 'لتأكيد أن حسابك قد تم حذفه',
  user_apply_delete_account_confirm_tip6: 'لإلغاء طلبك، يرجى النقر على "إلغاء"',
  user_apply_delete_data_always: 'هل تريد إلغاء طلب الحذف الدائم لحسابك التجريبي وبياناتك الشخصية؟',
  cancel_delete_yes: 'تأكيد',
  cancel_delete_no: 'إلغاء',
  user_cancel_delete_success: 'لقد ألغينا طلبك، ولن يتم حذف حساب HSK Mock الخاص بك.',
  user_cancel_subscribe_again: 'يمكنك إعادة الاشتراك مرة أخرى.',
  user_apply_delete_account_confirm_tip9: 'تاريخ انتهاء اشتراكك هو',
  user_apply_delete_account_confirm_tip10: 'يرجى اختيار وقت إلغاء الحساب',
  user_apply_delete_account_ok_btn_title: 'عند انتهاء الاشتراك',
  user_apply_delete_account_now_btn_title: 'إلغاء الآن',
  cancel_out_subscription_abnormal: 'معلومات اشتراك المستخدم غير طبيعية',
  user_apply_delete_account_confirm_tip3: 'لديك اشتراك على Apple، وسيتم تحصيل الرسوم تلقائيًا. يرجى إلغاء اشتراك Apple قبل التجديد',
  user_apply_delete_stripe_tip: 'سيقوم Stripe بتحصيل الرسوم تلقائيًا من بطاقتك الائتمانية/الخصم. يرجى زيارة موقعنا',
  user_apply_delete_account_balance: 'رصيد حسابك هو',
  user_apply_delete_account_balance_tip: 'بمجرد الحذف، لن يتم استرداد الرصيد.',
  user_apply_delete_account_expire: 'سيتم إلغاء حسابك خلال ثلاثة أيام',
  my_class_name: 'صفي',
  my_class_search: 'بحث عن صف',
  my_class_total: 'الإجمالي',
  my_class_people: 'أشخاص',
  my_class_ci: 'مرات',
  my_class_number: 'عدد الأشخاص',
  my_class_ci_number: 'عدد المرات',
  my_class_tips: 'الدائرة الداخلية: نسبة توزيع HSK و YCT',
  my_class_tips1: 'الدائرة الخارجية: نسبة توزيع مستويات HSK و YCT',
  my_class_all_class: 'جميع الصفوف',
  follow_lesson: 'عرض الدروس',
  real_paper: 'إجراء اختبار تجريبي كامل',
  start_answer: 'ابدأ الإجابة',
  edit_message_date: 'التاريخ',
  edit_message_language: 'اللغة',
  edit_message_zh: 'صيني',
  edit_message_en: 'إنجليزي',
  edit_message_title: 'العنوان',
  edit_message_content: 'يرجى إدخال النص',
  edit_message_show: 'عرض',
  edit_message_save_success: 'تم الحفظ بنجاح!',
  edit_message_create_success: 'تمت الإضافة بنجاح!',
  edit_message_edit1: 'تعديل',
  edit_message_follow_notice: 'عرض الإشعارات',
  edit_message_textarea_tips: 'إذا أضفت رابطًا، يرجى إضافة مسافة بعد الرابط للفصل',
  edit_message_notifications: 'تعديل الإشعارات',
  edit_message_Send_time: 'وقت الإرسال',
  edit_message_edit_notification: 'تعديل الإشعار',
  edit_message_add: 'إضافة إشعار',
  edit_message_from: 'وقت البداية',
  edit_message_to: 'وقت النهاية',
  edit_message_new_add: 'إضافة إشعار جديد',
  currency: 'اختيار العملة',
  pay_failed: 'لم يتم تحميل الصفحة بنجاح؟',
  pay_un_finished: 'تعذر إتمام الدفع',
  select_currency_tips: 'إذا رغبت، يمكنك اختيار عملة مختلفة من القائمة المنسدلة أدناه',
  change_currency_tips: 'يمكنك تغيير عملتك المفضلة في أي وقت من "حسابي".',
  my_homework: 'واجباتي',
  my_homework_add: 'تعيين واجب',
  my_homework_all_classes: 'جميع الصفوف',
  my_homework_paper: 'اسم الاختبار',
  my_homework_sent_to: 'إرسال إلى',
  my_homework_sent_on: 'وقت الإرسال',
  my_homework_due_on: 'تاريخ الاستحقاق',
  my_homework_submitted_assignees: 'عدد المرسلين/عدد المستلمين',
  my_homework_class_hint: 'الأيقونة بجوار اسم الصف تشير إلى أن الواجب تم تعيينه لبعض الطلاب فقط',
  my_homework_delay_hint: 'عرض ما إذا كان يمكن للطلاب تسليم الواجب بعد الموعد النهائي',
  my_homework_add_send_assignment: 'إرسال الواجب',
  my_homework_add_new_assignment: 'نشر واجب',
  my_homework_edit_assignment: 'تعديل المهمة',
  my_homework_add_assignment: 'إضافة مهمة',
  my_homework_add_assignment_details: '1. تفاصيل الواجب',
  my_homework_add_issue_time: 'وقت النشر',
  my_homework_add_whether_submit: 'السماح بالتسليم بعد الموعد النهائي',
  my_homework_add_note: 'ملاحظات',
  my_homework_add_assignees: '2. المستلمون',
  my_homework_edit_add_assignees: 'المستلمون',
  my_homework_add_group: 'اختيار الدرس',
  my_homework_add_immediate_release: 'نشر فوري',
  my_homework_add_time_release: 'نشر مجدول',
  my_homework_add_are: 'نعم',
  my_homework_add_no: 'لا',
  my_homework_detail_back: 'العودة إلى واجباتي',
  my_homework_detail_sent_to: 'أُرسلت إلى',
  my_homework_detail_leamers_in: 'طالب في',
  my_homework_detail_on: 'في',
  my_homework_detail_to_complete_by: 'أُرسلت في',
  my_homework_detail_add_assignee: 'إضافة مستلم',
  my_homework_detail_assignee: 'المستلم',
  my_homework_search_placeholder: 'الرجاء إدخال محتوى البحث',
  my_homework_stu_sent_by: 'المرسل',
  my_homework_total_topic_count: 'إجمالي {count} سؤال',
  my_homework_time_full: '{min} دقيقة',
  my_homework_select_date_time: 'اختر التاريخ والوقت',
  my_homework_delete_assignment_title: 'حذف الواجب',
  my_homework_delete_assignment_tips: 'هل أنت متأكد من حذف الواجب؟ لا يمكن التراجع بعد الحذف!',
  my_homework_assignment_add_fail: 'فشل النشر!',
  my_homework_assignment_add_success: 'تم النشر بنجاح!',
  my_homework_assignment_edit_success: 'تم التعديل بنجاح!',
  my_homework_assignment_edit_fail: 'فشل التعديل!',
  my_homework_assignment_delete_fail: 'فشل الحذف!',
  my_homework_assignment_delete_success: 'تم الحذف بنجاح!',
  my_homework_assignment_due_on: 'تاريخ الاستحقاق',
  my_homework_assignment_product: 'اسم المنتج',
  my_homework_assignment_certificate: 'شهادة',
  my_homework_assignment_reset: 'إعادة تعيين',
  my_homework_assignment_reset_title: 'هل تريد إعادة تعيين الوحدة المحددة؟',
  my_homework_assignment_gifted: 'عدد الهدايا',
  my_homework_assignment_papers: 'ورقة اختبار',
  my_homework_assignment_send_to: 'تم إرسال الواجب إلى',
  my_homework_assignment_close_tip: 'لم يتم حفظ الواجب الحالي، هل تريد الخروج؟',
  pay_callback_tips: 'إذا كنت في الصين القارية، ولكنك لست مواطنًا صينيًا، نوصيك باستخدام بطاقة Visa أو MasterCard. نحن نعمل على حل سيدعم WeChat وAlipay وبطاقة UnionPay الخاصة بك.',
  no_available_class: 'لا توجد فصول متاحة للاختيار',
  payment_method: 'طريقة الدفع',
  wechat_pay: 'الدفع عبر WeChat',
  alipay_payment: 'الدفع عبر Alipay',
  card_payment: 'الدفع بالبطاقة',
  card_payment_description: 'للبطاقات المصرفية الأجنبية فقط',
  payment_to_wohui: 'الدفع إلى Wo Hui Technology (Shanghai) Co., Ltd.',
  order_submitted: 'تم إرسال الطلب، يرجى الدفع في أسرع وقت ممكن!',
  order_number: 'رقم الطلب:',
  code_expires: 'الوقت المتبقي لانتهاء صلاحية رمز الاستجابة السريعة هو <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: 'يرجى استخدام WeChat لمسح رمز الاستجابة السريعة للدفع',
  code_expired: 'رمز الاستجابة السريعة الحالي غير صالح',
  amount_payable: 'المبلغ المستحق:',
  use_code: 'استخدام رمز الاستبدال',
  tests: 'سجل الامتحانات',
  level_title: 'ما هو المستوى المستهدف لديك؟',
  level_des: 'إذا لم تكن متأكدًا، يرجى النقر على <b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">اختبار المستوى المجاني ></b>',
  level_HSK_text1: '<b>HSK</b> هو اختصار拼音 لامتحان الكفاءة في اللغة الصينية، بمعنى اختبار مستوى اللغة الصينية.',
  level_HSK_text2: 'هذا هو أكثر اختبار كفاءة في اللغة الصينية شيوعًا في العالم.',
  level_YCT_text1: '<b>YCT</b> هو اختصار باللغة الإنجليزية لامتحان مستوى اللغة الصينية للتلاميذ.',
  level_YCT_text2: 'يعني اختبار مستوى اللغة الصينية المخصص للتلاميذ.',
  level_PRIMARY: 'ابتدائي',
  level_BEGINNER: 'مبتدئ',
  level_INTERMEDIATE: 'متوسط',
  level_ADVANCED: 'متقدم',
  level_dialog_title: 'اختبار المستوى',
  level_dialog_content: 'يستغرق الاختبار المجاني للمستوى حوالي 15 دقيقة، وستظهر النتيجة مستوى HSK الذي وصلت إليه حاليًا ومدى قربك من هذا المستوى في أربع مهارات لغوية (الاستماع، القراءة، الكتابة، التحدث).',
  level_dialog_login: 'تسجيل الدخول/التسجيل',
  level_dialog_start: 'بدء اختبار المستوى',
  about_us_first_paragraph: '<b>HSK Mock</b> هو المنصة الرسمية الوحيدة للاختبارات التجريبية لـ HSK وYCT، وهي أكثر اختبارات الكفاءة في اللغة الصينية شيوعًا في العالم. هذه المنصة هي نتاج تعاون بين <b>Hanban International</b> و<b>Wo Hui Mandarin</b>.',
  about_us_second_paragraph: '<b>Hanban International</b> (CTI) هو مجلس امتحانات HSK وYCT. وهي شركة مقرها بكين، تقدم مجموعة من الخدمات للأفراد والمؤسسات لدعم ونشر تعلم اللغة الصينية وتعليمها واختبارها كلغة أجنبية على مستوى العالم.',
  about_us_third_paragraph: '<b>Wo Hui Mandarin</b> (Wo Hui) توفر منصة رسمية عبر الإنترنت لدورات واختبارات HSK وYCT. وهي شركة مقرها سنغافورة، تستخدم التكنولوجيا لمنح الطلاب حرية التعلم وتزويد المعلمين بالأدوات والموارد لدعم رحلات التعلم الفردية للطلاب.',
  about_us_cti_text: 'تعرف على المزيد:',
  about_us_wohui_text: 'إذا كنت ترغب في معرفة المزيد، يرجى الاتصال:',
  listening_section: 'قسم الاستماع',
  reading_section: 'قسم القراءة',
  writing_section: 'قسم الكتابة',
  review_answers: 'مراجعة الإجابات',
  characters_long: 'إذا لم تقم بتسجيل حساب، يرجى تعيين كلمة مرور من 6 إلى 20 حرفًا.',
  complete_profile: 'أكمل ملفك الشخصي',
  verify_email: 'تحقق من بريدك الإلكتروني',
  link_sent: 'شكرًا لتسجيلك. يرجى النقر على الرابط الذي أرسلناه إليك للتحقق من بريدك الإلكتروني:',
  resend_link: 'إعادة إرسال الرابط >',
  restart: 'إعادة التشغيل',
  parental_consent: 'موافقة الوالدين',
  sent_parental: 'شكرًا لتسجيلك. يرجى اتباع التعليمات في البريد الإلكتروني الذي أرسلناه للحصول على موافقة والديك أو الوصي:',
  thank_you: 'شكرًا!',
  or_return: 'أو العودة إلى البرنامج',
  child_profile: 'الملف الشخصي لطفلك',
  sign_up_privacy: 'لقد قرأت ووافقت على <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">《شروط الخدمة》</a> و<a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">《سياسة الخصوصية》</a>',
  give_consent: 'أوافق',
  delete_child_details: 'حذف تفاصيل الطفل',
  account_created: 'تم إنشاء الحساب',
  emailed_know: "لقد أرسلنا بريدًا إلكترونيًا إلى <span style='font-weight: 700'>{email}</span> لإبلاغهم.",
  account_deleted: 'تم حذف الحساب',
  child_know_deleted: 'يرجى إعلام طفلك بأن تفاصيله قد تم حذفها.',
  request_email: 'يمكن تحديث المعلومات أعلاه (باستثناء البريد الإلكتروني) بعد تسجيل الدخول. يرجى الموافقة على إنشاء طفلك للحساب، أو اطلب منا حذف تفاصيله.',
  preferred_currency: 'العملة المفضلة',
  parent_guardian: 'الوالد/الوصي',
  class_name: 'اسم الصف',
  // start
  tofficial_platform: 'المنصة الرسمية الوحيدة لامتحان HSK التجريبي',
  tofficial_platform_new: 'المنصة الرسمية لامتحان HSK التجريبي',
  proficiency_tests: 'استعد لأشهر اختبار كفاءة في اللغة الصينية في العالم',
  proficiency_tests_new: 'مجموعة كاملة من أوراق الامتحان الحقيقية، تقييم مهني، تعزيز المفردات، وتمارين ذكية لمساعدتك على التحضير بكفاءة',
  get_started: 'ابدأ الاستخدام',
  get_started_new: 'ابدأ',
  start_practicing: 'ابدأ التمرين',
  get_ready: 'ابدأ التحضير لامتحان HSK من الآن!',
  real_hsk_exam_content: 'أوراق امتحان حقيقية',
  real_hsk_exam_desc: 'تدرّب باستخدام أوراق امتحان حقيقية، استعد بكفاءة وادخل الامتحان بثقة.',
  official_level_scoring: 'تقييم مهني',
  official_level_scoring_desc: 'تقييم وفقًا لمعايير HSK الرسمية، النتائج موثوقة وموثوقة.',
  vocabulary_boost: 'تعزيز المفردات',
  vocabulary_boost_desc: 'استخدم بطاقات المفردات المجانية وأدوات التدريب الذكية لحفظ كل كلمة بسهولة!',
  get_hsk_ready: 'الدليل الكامل للتحضير لـ HSK',
  how_it_works: 'كيفية الاستخدام',
  choose_your_level: 'اختر المستوى',
  choose_your_level_desc: 'اختر مستوى الامتحان المناسب لك —— من HSK المستوى الأول إلى HSK المستوى التاسع.',
  practise_and_learn: 'التعلم والتقييم',
  practise_and_learn_desc: 'ابدأ بتدريب المفردات المجاني! قم بترقية الحساب لفتح اختبارات HSK الرسمية الكاملة وخدمة التقييم الذكي.',
  track_your_progress: 'تتبع تقدمك',
  track_your_progress_desc: 'بعد كل اختبار، راجع درجات كل قسم، وتتبع تقدمك باستمرار، وحدد اتجاه التحسين بوضوح، وخطط وقت التحضير بكفاءة.',

  got_questions: 'لديك أسئلة؟ لدينا إجابات',
  faq: 'الأسئلة الشائعة',
  faq_desc: 'الأسئلة الشائعة حول التحضير لـ HSK ومنصة HSK Mock.',
  faq_btn: 'عرض الأسئلة الشائعة',

  blog: 'المدونة',
  blog_desc: 'تصفح مدونتنا لاكتشاف نصائح صغيرة حول التحضير لـ HSK.',
  blog_btn: 'تصفح المدونة',

  contact: 'اتصل بنا',
  contact_desc: 'هل تحتاج إلى مساعدة مخصصة؟ إذا كان لديك أي سؤال، يرجى الاتصال بفريق خدمة العملاء لدينا.',
  contact_btn: 'اتصل بنا',

  mock_tests: 'امتحانات تجريبية',
  blog_and_faq: 'المدونة & الأسئلة الشائعة',
  real_results_from_real_learners: 'نتائج حقيقية من متعلمين حقيقيين',
  support: 'المساعدة والدعم',
  choose_your_hsk_level: 'اختر مستوى HSK الخاص بك',
  choose_your_hsk_level_desc: 'استعد لامتحان HSK وHSK الشفوي وYCT باستخدام الامتحانات التجريبية الرسمية والأدوات الذكية.',

  hsk_levels: 'HSK',
  hsk_speaking: 'HSK الشفوي',
  yct: 'YCT',
  hsk_levels_tri: 'HSK3.0',

  start_learning: 'ابدأ التعلم الآن!',
  for_institutions: 'المدارس ومؤسسات التعليم المختلفة',

  for_hsk3_condidates: 'مناسب لممتحني HSK المستوى 3',
  for_hsk4_condidates: 'مناسب لممتحني HSK المستوى 4',
  for_hsk56_condidates: 'مناسب لممتحني HSK المستويين 5-6',

  platform_china: 'توفر هذه المنصة أيضًا الدعم للطلاب في الصين القارية.',
  take_confidence: 'ادخل امتحان HSK واثقًا من النجاح',
  practice_tests: 'تجارب عملية لـ HSK وYCT',
  using_time: 'استخدم أحدث أوراق الامتحان الرسمية المقدمة من Hanban، تعرف على أنواع الأسئلة المختلفة، وأتقن متطلبات الامتحان، وحسّن سرعة الإجابة، وأكمل الامتحان بنجاح.',
  instant_results: 'احصل على النتائج فورًا',
  each_test_question: 'راجع كل سؤال أجبته بعد كل اختبار، سترى نتيجتك، بالإضافة إلى تفاصيل الحل والإجابة الصحيحة. افهم نقاط قوتك وضعفك، صحح أخطاءك، وحدد اتجاهك نحو النجاح.',
  track_progress: 'سجل خطوات تقدمك',
  ready_next_test: 'المنصة تسجل تلقائيًا تاريخ ووقت كل امتحان تجريبي، وكذلك تحسن مهاراتك وتغير درجاتك. هذه السجلات ستشير إلى أفضل وقت لدخول الامتحان الحقيقي لتحقيق أفضل نتيجة.',
  receive_official_certificates: 'احصل على شهادات رسمية',
  certificates_provide_evidence: 'لكل امتحان تجريبي تجتازه، ستتلقى شهادة تثبت أنك قد بلغت مستوى معينًا في اللغة الصينية.',
  ready_next_level: 'ابدأ المرحلة التالية',
  check_description: 'راجع شرح المستوى التالي لتوضيح هدفك. أعد قراءة متطلبات وقواعد الامتحان، راجع المفردات المطلوبة، شاهد محتوى الامتحان، وأتقن استراتيجياته.',
  on_the_move: 'هل تستخدم الهاتف المحمول؟',
  on_the_move_new: 'قم بتنزيل تطبيق HSK Mock،',
  download_mobile: 'انقر على الزر أدناه لتنزيل التطبيق على الهاتف المحمول',
  download_mobile_new: 'استعد لامتحان HSK في أي وقت وأي مكان.',
  footer: 'HSK Mock هو المنصة الرسمية لامتحان HSK التجريبي، يجمع بين أوراق الامتحان الحقيقية، التقييم المهني، تعزيز المفردات، والتمارين الذكية، لمساعدتك على التحضير بكفاءة.',
  hsk_beginner_advanced: '<span style="font-weight: 700">HSK</span> هو اختصار拼音 لامتحان الكفاءة في اللغة الصينية، بمعنى اختبار مستوى اللغة الصينية. إنه أشهر اختبار كفاءة في اللغة الصينية في العالم، ويتكون من 9 مستويات من المبتدئ إلى المتقدم.',
  more: 'المزيد >',
  more_menu: 'اعرف المزيد',
  ytc_beginner_advanced: "<span style='font-weight: 700'>YCT</span> هو اختصار باللغة الإنجليزية لامتحان مستوى اللغة الصينية للتلاميذ، بمعنى اختبار مستوى اللغة الصينية المخصص للتلاميذ. ويتكون من 4 مستويات من المبتدئ إلى المتوسط.",
  coming_end: 'إطلاق الامتحان الشفوي التجريبي في نهاية 2023',
  candidates_proficiency_speaking: 'هذا اختبار لقدرة المرشحين على التحدث باللغة الصينية.',
  level_oral_tests: "<span style='font-weight: 700'>HSKK</span> هو اختصار拼音 لامتحان الكفاءة الشفوي في اللغة الصينية، بمعنى اختبار مستوى التحدث باللغة الصينية.",
  check_test_dates: 'عرض تواريخ الامتحانات',
  book_test: 'التسجيل في الامتحان',
  international_platform: 'المنصة الصينية تقع في الصين القارية؛ المنصة الدولية تقع في سنغافورة. المنصتان مستقلتان عن بعضهما البعض. يرجى اختيار المنصة المناسبة لك.',
  mock_platform: 'المنصة الرسمية للامتحان التجريبي',
  home_proficiency_tests: 'استعد لأشهر اختبار كفاءة في اللغة الصينية',
  currency_type: 'اختيار العملة',
  Pick_your_level: 'اختر مستواك',
  About_this_level: 'مقدمة عن المستوى',
  test_session: 'جلسة اختبار',
  Learning_resources: 'موارد التعلم',
  Take_practice_test: 'امتحان تجريبي',
  Compare_syllabuses: 'مقارنة المناهج',
  table_shows_syllabuses: 'تُظهر هذه الجدول مستويات HSK من خلال المناهج المختلفة.',
  forrgin_lang: '0547 هو "اللغة الصينية كلغة أجنبية"',
  Second_Language: '0523 هو "اللغة الصينية كلغة ثانية"',
  Requirement_entry: 'شروط التسجيل',
  most_Chinese_universities: 'أغلب الجامعات الصينية',
  Qing_Hua: 'جامعة تسينغوا',
  beijing_university: 'جامعة بكين',
  working_towards: 'بعد الاختبار، يُوصى أن تستعد للامتحان',
  On: 'في',
  Level_test: 'اختبار المستوى',
  Retake_level_test: 'إعادة اختبار المستوى',
  practice_test: 'مشاركة في اختبار تجريبي',
  Compare_syllabuses_a: 'مقارنة بين المناهج المختلفة ومنهج HSK',
  Not_sure: 'غير متأكد من مستواك؟',
  free_level_test: 'شارك في اختبار مستوى مجاني',
  Examples: 'أمثلة',
  product_code: 'رمز المنتج',
  enter_paper: 'أدخل رمز التفعيل للمشاركة في الاختبار',
  no_code: 'لا يوجد لديك رمز؟ يمكنك شراءه من شركائنا:',
  to_partner: 'انتقل إلى رابط الشريك',
  code_here: 'يرجى إدخال رمز التفعيل هنا',
  start_assigment: 'ابدأ',
  view_assigment: 'عرض النتائج',
  continue_assigment: 'استمر',
  choose_method: 'اختر طريقة الفتح',
  choose_new_method: 'يرجى اختيار طريقة لفتح الاختبار الجديد.',
  browser_layer: 'يرجى استخدام متصفح Google Chrome على الكمبيوتر أو التطبيق على الجهاز المحمول',
  partner_title1: 'نتمنى أن تصبح',
  partner_title2: 'شريكًا محليًا',
  company_name: 'اسم الشركة',
  company_website: 'موقع الشركة الإلكتروني',
  teachers_count: 'عدد معلمي HSK الذين يتعاونون معك',
  learners_count: 'عدد طلاب HSK الذين يتعاونون معك',
  add_msg: 'مرحبًا بكم في ترك رسالة لنا',
  contact_style: 'كيف يمكننا الاتصال بك؟',
  send: 'انقر لإرسال',
  partner_forms_desc: 'بصفتك شريكًا محليًا لنا، ستكون نقطة الاتصال الرئيسية للمتقدمين للاختبارات والمعلمين والمدارس والجامعات في بلدك أو منطقتك.<br><br>عادةً ما يكون شركاؤنا في الاختبار والتدريب لمستوى HSK مراكز ناضجة تتطلع إلى توسيع أعمالهم وزيادة الاعتراف الرسمي. <br><br>إذا كنت ترغب في أن تصبح شريكًا محليًا، يرجى أولاً استخدام حسابك الشخصي في منصة HSK Mock <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">تسجيل الدخول</span> وملء التفاصيل أدناه، وسنتواصل معك قريبًا.',
  submit_success: 'تم الإرسال بنجاح',
  help_students_for_testing: 'هل تساعد الطلاب في الاستعداد للاختبار؟',
  help_students_for_testing_desc: 'يلعب المعلمون دورًا حيويًا في مساعدة الطلاب على الوصول إلى هدف الاختبار التالي. <br>تمكين المعلمين لتقديم دعم تعلم مخصص للطلاب.',
  become_partner: 'كن شريكنا المحلي',
  become_partner_desc: 'بالنسبة للمتقدمين للاختبار، يمكنهم التواصل مع مركز الاختبار المحلي بلغة الأم، واختيار طريقة الدفع المحلية المفضلة لديهم.',
  partnership: 'استكشاف الشراكة',
  students_forward: 'دعم طلابك',
  hsk_confidence: 'ادخل اختبار HSK بثقة!',
  try_it_out: 'جربه الآن',
  walk_through: 'تعرف على عملية الامتحان',
  teachers_page_desc1: 'تدعم منصة الاختبار هذه التدريس الجماعي وكذلك التدريس الفردي. تساعد الطلاب على التعرف على أنواع الأسئلة المختلفة، مراجعة المفردات المحددة، معاينة محتوى الامتحان، واكتساب مهارات الامتحان.',
  assign_practice_papers: 'حدد الموعد النهائي لتقديم الامتحان للطلاب',
  teachers_page_desc2: 'ونشر أوراق الامتحان الخاصة بك للطلاب. يمكنك استخدام أوراق الامتحان التجريبية كاختبار رسمي لمساعدة الطلاب في التعرف على الأنواع المختلفة من الأسئلة في اختبار HSK، حتى يتمكنوا من إتمام الإجابة ضمن الوقت المحدد.',
  get_instant_results: 'الحصول على نتائج فورية',
  teachers_page_desc3: 'لا حاجة لتصحيح الأوراق يدويًا. راقب ما إذا كان الطلاب قد أكملوا ورقة الامتحان المحددة. يمكنك عرض درجات كل ورقة اختبار للطلاب.',
  review_their_answers: 'مراجعة إجابات الطلاب',
  teachers_page_desc4: 'يمكنك الحصول على تفاصيل حول درجات الطلاب حسب الفصل الدراسي، المهارة، الجزء وحتى السؤال. من خلال مراجعة إجابات الطلاب، يمكنك وضع خطة تعليمية دقيقة وتقديم تعليقات مخصصة.',
  track_prog: 'متابعة تقدم الطلاب',
  teachers_page_desc5: 'يتم تسجيل درجات الطلاب في كل اختبار بدقة، مع تفاصيل الإجابات على كل سؤال، وكذلك التغييرات في المهارات والدرجات. تساعد هذه السجلات المعلمين على معرفة الوقت الأمثل للطلاب للمشاركة في الاختبارات الفعلية وتحقيق أفضل الدرجات.',
  students_next_level: 'مساعدة الطلاب على الوصول إلى المستوى التالي',
  teachers_page_desc6: 'توفر منصتنا الشقيقة مواد دراسية رسمية لـ HSK و YCT، بالإضافة إلى الأدوات والموارد التعليمية التي يحتاجها المعلمون لتمكين الطلاب من الحصول على دعم مخصص في تعلمهم.',
  teaching_resources: 'موارد التدريس',
  for_teachers: 'للمعلمين',
  teachers_desc1: 'يرجى تسجيل الدخول أولاً باستخدام حسابك الشخصي في منصة HSK Mock <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">تسجيل الدخول</span>.',
  teachers_desc2: 'يرجى ملء المعلومات الأساسية أدناه، وسنقوم بتوفير فترة تجربة مجانية لمدرستكم.',
  school_name: 'اسم المدرسة',
  school_web: 'موقع المدرسة الإلكتروني',
  num_of_hsk_teachers: 'عدد معلمي HSK',
  num_of_hsk_learners: 'عدد طلاب HSK',
  hsk_submit_reading: 'قراءة',
  pay_tip: 'إذا كنت تقوم بالدفع عبر Alipay أو WeChat لشراء أوراق الامتحان التجريبية، يرجى استخدام الموقع الإلكتروني في الصين الحجز hskmock.cn.',
  use_pc_or_app: 'جرب الآن باستخدام الكمبيوتر أو تحميل تطبيقنا.',
  download_certificate: 'تحميل الشهادة',
  create_certificate: 'إنشاء الشهادة',
  certificate_is_downloaded: 'تم تنزيل الشهادة',
  pay_discount_title: 'كم عدد اختبارات HSK التي ترغب في شرائها للمستوى {level}؟',
  total: 'الإجمالي',
  pay: 'الدفع',
  price_desc: 'تدفع فقط رسوم الاختبار التجريبي الفعلي. إذا قمت بشراء العديد من اختبارات الامتحانات التجريبية في وقت واحد، ستحصل على خصم على السعر الفردي.',
  the_level: 'المستوى',
  discounted_price: 'السعر',
  price_contact_us: 'نحن نقدم خدمة شراء بالجملة للمدارس والمؤسسات. يرجى <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">الاتصال بنا</span> لمناقشة احتياجاتك الخاصة.',
  get_a_discount: 'احصل على خصم',
  finished_pay_discount_title: 'هذه هي رموز التفعيل لاختبارات المحاكاة للمستوى {level_name}.',
  btn_goto_papers: 'عرض أوراق {level_name}',
  test_count: '{test_num} اختبار',
  unit_price: '{price}/اختبار',
  buy_code_tip: 'لقد أرسلنا هذه الرموز إليك عبر البريد الإلكتروني. الآن اختر اختبار المستوى {level_name} الذي ترغب في إجرائه، وأدخل رمز التفعيل لفتح الاختبار.',
  discount_codes_left_tip: 'بعد الاختبار، ستتبقى لديك <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count} رموز تفعيل</span> للمستوى الحالي.',
  manage_class: 'إدارة الفصل',
  to_manage_class: "سيتم فتح نظام إدارة الصفوف في علامة تبويب جديدة. بعد الانتهاء، يرجى العودة إلى هذه الصفحة وتحديثها.",
  code_used: "مستخدم",
  code_can_be_used: "غير مستخدم",
  no_test: "الكمية",
  history_purchase_quantity: "الكمية",
  hsk_listen_part_title: "قسم الاستماع رقم {count}",
  hsk_read_part_title: "قسم القراءة رقم {count}",
  hsk_write_part_title: "قسم الكتابة رقم {count}",
  Description: "مقدمة",
  Test_format: "شكل الامتحان",
  Vocabulary: "المفردات",
  vocab_type: "نوع الكلمة",
  sso_login_signup: "تسجيل الدخول / التسجيل",
  sso_email_address: "عنوان البريد الإلكتروني",
  sso_password: "كلمة المرور",
  sso_characters_long: "إذا لم تقم بعد بإنشاء حساب، يرجى تعيين كلمة مرور مكونة من 6 إلى 20 حرفًا.",
  sso_forget_pw: "نسيت كلمة المرور",
  sso_agree_policy: "لقد قرأت ووافقت على <u class=\"strong\"><a href=\"{url}\" target=\"_blank\">اتفاقية المستخدم</a></u> و<u class=\"strong\"><a href=\"{userUrl}\" target=\"_blank\">سياسة الخصوصية</a></u>",
  sso_continue: "متابعة",
  sso_please_check: "يرجى تحديد أنك قرأت ووافقت على اتفاقية المستخدم وسياسة الخصوصية",
  sso_invalid_email_address: "عنوان بريد إلكتروني غير صالح",
  sso_invalid_password: "صيغة كلمة المرور غير صحيحة",
  sso_loading: "جارٍ التحميل",
  sso_mock_platform: "المنصة الرسمية للاختبار التجريبي",
  sso_home_proficiency_tests: "استعد لاختبار الكفاءة في اللغة الصينية الأكثر شيوعًا",
  sso_guardian_consent_error: "فشل العملية",
  sso_forget_pw_success: "تم إرسال رسالة إعادة تعيين كلمة المرور بنجاح",
  sso_forget_pw_error: "فشل إرسال رسالة إعادة تعيين كلمة المرور",
  sso_log_in_error: "فشل تسجيل الدخول",
  sso_download_app_mobile: "للحصول على تجربة أفضل، يرجى استخدام إصدار سطح المكتب على hskmock.com أو تنزيل التطبيق",
  sso_no_binding_info_tip: "تعذر الحصول على معلوماتك التفصيلية",
  sso_third_login_tip: "يرجى اختيار الموقع الذي تريد فتحه",
  sso_third_login_wohui: "الانتقال إلى موقع 我会中文",
  sso_third_login_mock: "الانتقال إلى HSK Mock",
  other_gender: "سرّي/آخر",
  hsk_enter_listening: "الاستماع",
  intro_msg_first: "يتكون هذا الامتحان من {num} أقسام، ويجب عليك إكمالها بالترتيب.",
  intro_msg_second: "يرجى إكمال كل قسم ضمن الوقت المحدد.",
  intro_msg_third: "إذا أنهيت القسم الحالي قبل انتهاء الوقت، يمكنك الانتقال إلى القسم التالي، ولكن لا يمكنك العودة إلى الأقسام السابقة.",
  dialogue_listening: "الجزء الأول هو اختبار الاستماع. يرجى النقر على الزر لتشغيل الصوت أدناه وضبط جهازك حسب الحاجة.",
  dialogue_listening_hskk: "يرجى النقر على الزر لتشغيل الصوت أدناه وضبط جهازك حسب الحاجة.",
  dialogue_intro_msg_first: "أثناء تشغيل الموسيقى، سيتم تشغيل مقدمة عامة عن الامتحان. خلال هذه المقدمة، يمكنك معاينة أسئلة قسم الاستماع.",
  dialogue_intro_msg_first_hskk: "أثناء تشغيل الموسيقى، سيتم تشغيل مقدمة عامة عن الامتحان.",
  dialogue_intro_msg_second: "لتمثيل الامتحان الحقيقي، لا يمكنك إيقاف أو إعادة تشغيل أو تقديم الصوت في قسم الاستماع.",
  dialogue_intro_msg_second_hskk: "لتمثيل الامتحان الحقيقي، لا يمكنك إيقاف أو إعادة تشغيل أو تقديم الصوت.",
  dialogue_intro_msg_third: "بعد انتهاء الصوت في قسم الاستماع، سيكون لديك {duration} دقيقة لمراجعة إجاباتك.",
  dialogue_intro_question: "هل تواجه مشكلة؟",
  dialogue_preload_intro_first: "جارٍ تحميل الصوت لقسم الاستماع.",
  dialogue_preload_intro_second: "بمجرد اكتمال التحميل، سيتم تشغيل الصوت تلقائيًا ويبدأ الاختبار.",
  dialogue_preload_intro_third: "حظًا موفقًا!",
  dialogue_preload_title: "جارٍ تنزيل موارد الامتحان",
  mock_paper_preview: "معاينة ورقة الامتحان التجريبية",
  dialogue_mock_paper_intro_title: "تعليمات الامتحان",
  dialogue_mock_paper_intro_sentence1: "سيستغرق هذا الامتحان حوالي {minutes} دقيقة. يرجى التأكد من أن لديك الوقت الكافي والطاقة لإكماله دفعة واحدة.",
  dialogue_mock_paper_intro_sentence2: "سيتم إجراء هذا الامتحان بالكامل عبر الإنترنت، لذا تأكد من أن لديك اتصال إنترنت ثابت.",
  dialogue_mock_paper_intro_sentence3: "إذا كنت تستخدم جهاز كمبيوتر مكتبي أو محمول، يرجى استخدام أحدث إصدار من Chrome أو Safari.",
  dialogue_mock_paper_intro_sentence4: "إذا كنت تستخدم جهازًا لوحيًا، يرجى استخدام تطبيقنا بدلاً من المتصفح.",
  dialogue_mock_paper_intro_sentence5: "أثناء الامتحان، لا تفتح نوافذ متصفح أخرى أو تطبيقات أخرى، ولا تغير اللغة أو توصل/تفصل أجهزة أخرى (مثل USB، سماعات الرأس، إلخ).",
  diologue_mock_paper_quit: "خروج",
  dialogue_mock_paper_intro_button: "لقد قرأت وفهمت",
  deadline_passed: "انتهى الموعد النهائي",
  mock_skip_introduction: "تخطي التعليمات؟",
  Listening: "الاستماع",
  Reading: "القراءة",
  Writing: "الكتابة",
  personal_info_display_name_as: "الاسم على الشهادة",
  code_pratice_text: "استخدم <span style=\"font-weight: 600;color: #0C0C0C\">{paper_name}</span> لإجراء اختبار تجريبي <span style=\"font-weight: 600;color: #0C0C0C\">{level_name}</span>",
  code_input_text: "أدخل رمز التفعيل:",
  use_code_limit: "كل رمز تفعيل يمكن استخدامه مرة واحدة فقط",
  code_select_text: "أو اختر رمز تفعيل:",
  pay_discounts_desc1: "من خلال ممارسة الامتحانات السابقة، يمكنك",
  pay_discounts_desc2: "الحصول على أفضل نتيجة في امتحانك [{type}] [{level}]",
  pay_discounts_desc3: "اشترِ واحدًا واحصل على آخر مجانًا",
  pay_discounts_desc4: "إذا كنت قد سجلت بالفعل في امتحان [{type} {level}] رسمي، فيمكنك الاستفادة من عرض \"اشترِ واحدًا واحصل على آخر مجانًا\" عند شراء ورقة امتحان تجريبية [{type} {level}]",
  pay_discounts_desc5: "كم عدد أوراق الامتحان التجريبية التي ترغب في شرائها؟",
  level_HSKK_text1: "اختبار HSKK الشفوي يقيم قدرة المتقدمين على التحدث باللغة الصينية. ويشمل ثلاث مستويات: الابتدائي، المتوسط، والمتقدم.",
  level_HSKK_text2: "يتم إجراء اختبار HSKK الشفوي في شكل تسجيل صوتي.",
  level_HSKK_text3: "يجب على المتقدمين لمستوى HSK3 اجتياز مستوى HSKK الابتدائي، وطلاب HSK4 يجب أن يجتازوا مستوى HSKK المتوسط، بينما HSK5 و HSK6 يجب أن يجتازوا مستوى HSKK المتقدم.",
  test_download_desc: "ورقة الامتحان التجريبية لهذا المستوى قيد التحضير. في الوقت نفسه، يرجى تنزيل:",
  speaking: "التحدث",
  Traduction: "الترجمة",
  my_homework_none_homework: "هذا المستوى لا يدعم بعد تعيين أوراق الامتحان التجريبية، يرجى الانتظار.",
  my_class_none_test: "هذا المستوى لا يدعم بعد إجراء أوراق الامتحان التجريبية عبر الإنترنت، يرجى الانتظار.",
  hsk_audio_error: "شبكتك غير مستقرة حاليًا، فشل تحميل الصوت، يرجى المحاولة مرة أخرى.",
  mock_join_campus_text1: "هل تقبل الدعوة للانضمام إلى مجتمع تعليم واختبار اللغة الصينية؟",
  mock_join_campus_text2: "بعد الانضمام، يمكن للمعلمين تعيين أوراق الامتحان لك على HSKMock.com، أو تعيين التدريبات على app.wohuimandarin.com.",
  sso_join_campus_text4: "يمكن للمعلمين مراجعة إجاباتك لتقديم ملاحظات موجهة.",
  join: "انضم",
  free_practice_title: "تدريب مجاني",
  choose_free_practice: "اختر طريقة للتدريب",
  word_flashcards: "بطاقات الكلمات",
  word_practice: "تدريب الكلمات",
  analyse_text: "تحليل النص",
  flashcards_title: "بطاقات تعليمية",
  practice_exercises_title: "تمارين تدريبية",
  analyse_title: "تحليل",
  practice_result_title: "نتائج التدريب",
  generate_flashcards: "إنشاء مجموعة من البطاقات التعليمية",
  generate_practice: "إنشاء مجموعة من التمارين",
  random_select: "اختيار عشوائي",
  manual_select: "اختيار يدوي",
  max_words: "بحد أقصى {number} كلمة",
  already_choose: "تم الاختيار: {total} كلمات",
  free_practice_words_quantifier: "كلمة",
  free_practice_unchoose_question: "الرجاء اختيار نوع السؤال",
  free_practice_unchoose_practice: "الرجاء اختيار نوع التمرين",
  none_mark_words_hint: "في المستوى الحالي لم تحدد أي كلمات بعد",
  excceed_max_count: "يمكن اختيار {total} كلمة كحد أقصى، وقد وصلت إلى الحد الأعلى",
  free_practice_sound: "صوت",
  free_practice_question: "سؤال",
  free_practice_choose_exercise: "اختر نوع التمرين",
  free_practice_exercise_select: "اختيار من متعدد",
  free_practice_exercise_Pairs: "مطابقة",
  free_practice_exercise_TF: "صح/خطأ",
  launch: "ابدأ",
  free_practice_check_text: "هل أجبت بشكل صحيح؟",
  free_practice_timer_pause: "إيقاف مؤقت للمؤقت",
  free_practice_timer_pause_desc: "سيتم إيقاف المؤقت تلقائيًا عند عدم وجود نشاط",
  free_practice_seconds: "{number} ثانية",
  resume: "استئناف",
  flashcard_completed: "تم إكمال البطاقات التعليمية",
  practice_completed: "تم إكمال التمرين",
  practice_spent_minutes: "إجمالي الوقت: {duration} دقيقة",
  practice_result_summary: "ملخص النتائج",
  practice_result_progress_txt: "لقد حصلت على",
  practice_wrong: "خطأ",
  practice_skip: "تخطى",
  practice_done: "منجز",
  analyse_desc_1: "تحليل النص بناءً على قائمة المفردات المحددة",
  analyse_desc_2: "الصق أو اكتب نصًا صينيًا (بحد أقصى {maxCount} حرفًا)",
  analyse_input_placeholder: "أدخل النص الصيني",
  free_practice_need_word: "اختر كلمات من الجدول أو اختر كلمات عشوائية",
  free_practice_exercise_select_title: "اختر الإجابة الصحيحة",
  free_practice_exercise_pairs_title: "انقر للتوصيل والمطابقة",
  free_practice_exercise_meaning_title: "يجب أن يترجم إلى",
  free_practice_exercise_sound_title: "يجب أن يُنطق كـ",
  free_practice_exercise_characters_title: "يجب أن يُكتب كـ",
  free_practice_show_correct_answers: "عرض الإجابات الصحيحة",
  free_practice_show_my_answers: "عرض إجاباتي",
  free_practice_check: "تحقق",
  free_practice_correct: "صحيح",
  free_practice_characters: "حروف صينية",
  hsk_introduce_objective_questions: "أسئلة موضوعية",
  hsk_introduce_subjective_questions: "أسئلة إنشائية",
  hsk_input_type_here: "الرجاء الكتابة هنا",
  hsk_translation_part_title: "قسم الترجمة {count}",
  hsk_speaking_part_title: "قسم التحدث {count}",
  subjective_reading_placeholder: "الرجاء الإجابة عن الأسئلة بناءً على النص أعلاه…",
  hsk_write_by_artical: "الرجاء كتابة مقال استنادًا إلى المادة أعلاه…",
  hsk_translation_by_artical: "الرجاء الترجمة استنادًا إلى المادة أعلاه…",
  hsk_trasnlation_choose_language: "الجزء التالي هو الترجمة، الرجاء اختيار اللغة",
  choose_speaker: "اختر مكبر الصوت",
  choose_microphone: "اختر الميكروفون",
  hsk_is_recording: "جارٍ التسجيل",
  dialogue_speaking: "الجزء الأخير هو التحدث. الرجاء التأكد من أن مكبر الصوت والميكروفون يعملان بشكل صحيح على جهازك.",
  start_recording: "انقر لبدء التسجيل",
  hsk_write_count: "عدد الكلمات",
  error_access_media: "حدث خطأ أثناء الوصول إلى أجهزة الوسائط.",
  setSinkId_not_supported: "المتصفح الخاص بك لا يدعم {setSinkId}.",
  error_switch_device: "حدث خطأ أثناء تبديل الجهاز.",
  translation_section: "قسم الترجمة",
  speaking_section: "قسم التحدث",
  failed_upload_record: "فشل رفع التسجيل الصوتي، الرجاء إعادة الرفع.",
  hsk_enter_next_segment_write_high: "هل تريد إرسال الكتابة؟ بعد الإرسال ستنتهي مرحلة الكتابة ولا يمكن الرجوع للتعديل.",
  hsk_enter_next_segment_translate_tip: "لديك {count} أسئلة ترجمة غير مُجابة،",
  hsk_enter_next_segment_translate: "هل تريد إرسال الترجمة؟ بعد الإرسال ستنتهي مرحلة الترجمة ولا يمكن الرجوع للتعديل.",
  hsk_enter_next_segment_speaking_tip: "لديك {count} أسئلة محادثة غير مُجابة،",
  Translating: "ترجمة",
  Speaking: "تحدث",
  back_to_home: "العودة إلى الصفحة الرئيسية",
  about_us_desc:
    "<b>HSK Mock</b> هو منصة محاكاة عبر الإنترنت لامتحانات <b>HSK</b> و <b>HSK الشفوي</b> و <b>YCT</b> التي أطلقتها الجهة الرسمية. تعيد بشكل كبير مشهد الامتحان الحقيقي، لمساعدة المتعلمين على الاستعداد بثقة، وتقييم دقيق، وتحسين شامل.",
  who_we_are: "من نحن",
  who_we_are_desc:
    "تم تطوير HSK Mock بشكل مشترك من قبل <b>هانكاو الدولية (Chinese Testing International)</b> و <b>Wo Hui Mandarin 【我会中文】</b>، بهدف تزويد متعلمي اللغة الصينية حول العالم بأدوات محاكاة واختبارات موثوقة ورسمية.",
  why_choose_hsk_mock: "لماذا تختار HSK Mock؟",
  about_us_carousel_1: "بنك أسئلة رسمي",
  about_us_carousel_1_content:
    "يلتزم HSK Mock بدقة بهيكل امتحانات HSK و HSK الشفوي و YCT الرسمية.",
  about_us_carousel_2: "نظام تقييم موثوق",
  about_us_carousel_2_content:
    "يستخدم HSK Mock نفس معايير التقييم المعتمدة في الامتحانات الرسمية لتقييم مستوى المتقدمين بدقة.",
  about_us_carousel_3: "أدوات تعلم فعّالة",
  about_us_carousel_3_content:
    "يوفر HSK Mock أيضًا تدريبات تفاعلية على المفردات لكل مستوى، لتعزيز مهارات الاستماع والتحدث والقراءة والكتابة بشكل شامل.",
  about_us_carousel_4: "استخدام مرن على عدة أجهزة",
  about_us_carousel_4_content: "يدعم HSK Mock أجهزة الكمبيوتر والهواتف المحمولة، للتدريب بسهولة في أي وقت وأي مكان.",
  about_us_carousel_5: "خيار مشترك للمتعلمين حول العالم",
  about_us_carousel_5_content: "لقد ساعد HSK Mock متعلمين من جميع أنحاء العالم على تحقيق أهدافهم في تعلم اللغة الصينية.",

  for_teachers_banner_title: "منصة محاكاة رسمية مناسبة للمدارس والفرق العالمية",
  for_teachers_banner_desc: "منصة محاكاة HSK الرسمية تجمع بين الامتحانات الحقيقية، التقييم المهني، تعزيز المفردات، والتدريب الذكي. من خلال HSK Mock، يمكنك تقييم مستوى اللغة الصينية عبر الإنترنت في أي وقت، وتجربة امتحانات HSK و YCT الحقيقية. إنها الخيار الموثوق للمدارس الدولية والجامعات وفِرق الموارد البشرية والشركات العالمية.",
  for_teachers_banner_btn: "احجز عرضًا توضيحيًا",

  for_schools: "للSchools والمعلمين",
  for_schools_desc: "من خلال امتحانات محاكاة HSK و YCT الرسمية، نساعد الطلاب على الاستعداد بثقة.",
  for_schools_list_1: "عملية امتحان مطابقة للامتحان الرسمي، لمحاكاة بيئة حقيقية",
  for_schools_list_2: "يدعم عدة أجهزة، اختبار عبر الإنترنت في أي وقت",
  for_schools_list_3: "نتائج فورية لمستويات HSK 1-3 و YCT 1-4",
  for_schools_list_4: "متابعة تقدم الأفراد والفصول في أي وقت",

  for_corporates: "للشركات وفرق الموارد البشرية",
  for_corporates_desc: "تقييم اللغة الصينية بشكل مرن وسريع لتلبية احتياجات التنقل، الإيفاد، التوظيف والمتطلبات التجارية.",
  for_corporates_list_1: "اختبار لغوي قبل الإيفاد واختبارات معيارية داخلية",
  for_corporates_list_2: "نتائج فورية لمستويات HSK 1-3؛ نتائج مستويات HSK 4-6 خلال 48 ساعة",
  for_corporates_list_3: "تتبع التقدم بعد التدريب",
  for_corporates_list_4: "تقييم عبر الإنترنت أو دون اتصال في أي وقت وأي مكان",

  official_format: "إجراء رسمي",
  official_format_desc: "محاكاة واقعية لامتحانات HSK و YCT، لإعادة تجربة الامتحان الحقيقي.",
  smart_scoring: "تقييم مهني",
  smart_scoring_desc: "التقييم وفقًا للمعايير الرسمية.",
  progress_analytics: "تحليل التقدم",
  progress_analytics_desc: "تقديم تحليل وتتبع مفصل استنادًا إلى أداء الطلاب أو الفرق.",
  remote_access: "وصول عن بُعد",
  remote_access_desc: "قائم بالكامل على الإنترنت، متاح في أي وقت وأي مكان.",

  why_use_hsk: "منصة HSK Mock الرسمية مناسبة لـ",
  international_schools: "المدارس الدولية",
  international_schools_desc: "تقدم دورات لغة صينية وفقًا لمعايير HSK/YCT مع قدرات تقييم قابلة للتوسيع.",
  universities_institutes: "الجامعات والمعاهد المهنية",
  universities_institutes_desc: "توفير دعم رسمي للاختبارات لدورات اللغة الصينية الأكاديمية.",
  global_corporates: "الشركات العالمية",
  global_corporates_desc: "تقييم مستوى اللغة الصينية للموظفين في الوظائف الموجهة للسوق الصيني.",
  language_training_providers: "مزودو التدريب اللغوي",
  language_training_providers_desc: "تقديم امتحانات محاكاة مطابقة للمعايير الرسمية للمتعلمين.",

  ready_to_access: "هل أنت مستعد لتقييم مستوى لغتك الصينية؟",
  book_live_demo: "احجز عرضًا مباشرًا، واحصل على حساب تجريبي، واعرض تحليلات النتائج، وابدأ سريعًا باستخدام HSK Mock.",
  book_demo: "احجز عرضًا توضيحيًا"
}
